import urlJoin from 'url-join'
import qs, { Stringifiable } from 'query-string'

const getDocsURL = (
  assignmentID: string,
  queryParams: Record<
    string,
    string | number | boolean | readonly Stringifiable[] | null | undefined
  > = {}
): string => {
  if (typeof assignmentID !== 'string') {
    throw new Error(
      `ArgumentError: Expected 'assignmentID' to be of type 'string' but received type '${typeof assignmentID}'`
    )
  }

  const url = urlJoin('/document/', assignmentID)

  const result = qs.stringifyUrl(
    { url, query: queryParams },
    { skipEmptyString: true, skipNull: true }
  )

  return result
}

export default getDocsURL
